import React from "react";
import { Stack, useTheme } from "@mui/material";
import { darken, lighten } from "@mui/material/styles";

interface HeroBackdropProps {
    children: React.ReactNode;
}

const HeroBackdrop: React.FC<HeroBackdropProps> = ({ children }) => {
    const theme = useTheme();
    const primary = theme.palette.primary.main;

    return (
        <Stack
            width="100%"
            sx={{
                background: `linear-gradient(180deg, ${lighten(primary, 0.08)} 0%, ${darken(primary, 0.08)} 100%)`,
                pt: "56px",
                pb: "40px",
                px: 2,
                boxSizing: "border-box",
                position: "relative",
                "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    opacity: 0.04,
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
                    backgroundRepeat: "repeat",
                    backgroundSize: "128px 128px",
                    pointerEvents: "none",
                },
            }}
        >
            {children}
        </Stack>
    );
};

export default HeroBackdrop;
